import React, { useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { MeetingTemplate, useDeleteMeetingTemplateMutation } from '../../../store/ai/meetingTemplate'
import { selectAccountId } from '../../../store/auth/authSlice'
import { useAppSelector } from '../../../store/hooks'
import { Modal } from '../../../components/Modal/Modal'
import { TrackEvent, useTracking } from '../../../apps/professional-app/fa/common/tracking'

export interface UninstallMeetingTemplateModalProps {
  show: boolean
  onHide: () => void
  meetingTemplate: MeetingTemplate
}
export const UninstallMeetingTemplateModal: React.FC<UninstallMeetingTemplateModalProps> = ({ show, onHide, meetingTemplate }) => {
  const accountId = useAppSelector(selectAccountId)
  const [uninstallMeetingTemplate, { isSuccess, isLoading }] = useDeleteMeetingTemplateMutation()
  const { tracked } = useTracking()
  const handleDeleteMeetingTemplate = tracked(
    () => {
      uninstallMeetingTemplate({ accountId, meetingTemplateId: meetingTemplate.id })
    },
    { eventName: TrackEvent.MEETING_TEMPLATE_DELETED },
    { eventDetailsExtractor: () => ({ meetingTemplateId: meetingTemplate.id, name: meetingTemplate.name }) },
  )

  useEffect(() => {
    if (isSuccess) {
      onHide()
    }
  }, [isSuccess])

  const body = (
    <Container>
      <Row className='pb-3'>
        <Col>
          <h4 className='d-flex justify-content-center align-items-center'>Delete Meeting Template</h4>
        </Col>
      </Row>
      <Row className='pb-4'>
        <Col className='p-0'>
          <div className='paragraph-medium'>
            Are you sure you want to delete meeting type <b>{meetingTemplate.name}</b> ?
          </div>
        </Col>
      </Row>
    </Container>
  )
  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<></>}
      body={body}
      showFooterActions={true}
      onFooterPrimaryAction={handleDeleteMeetingTemplate}
      footerPrimaryActionLoading={isLoading}
      footerPrimaryActionTitle='Delete'
      footerPrimaryActionButtonVariant='danger'
    />
  )
}
